// extracted by mini-css-extract-plugin
module.exports = {"teacher":"TeacherDivisor_teacher__1zGnJ","text":"TeacherDivisor_text__2zUNg","image":"TeacherDivisor_image__BwJm8","rounded":"TeacherDivisor_rounded__3YAOC"};